export { default as responsiveFontSize } from './responsiveFontSize'
export { default as scrollTo } from './scrollTo'
export { default as getUrlParams } from './urlParams'
export {default as checkMobileBrowser } from './checkBrowser'
export {default as mobileRedirect} from './mobileRedirect'